import { render, staticRenderFns } from "./HelzbergCard.vue?vue&type=template&id=97296e36&scoped=true&"
import script from "./HelzbergCard.vue?vue&type=script&lang=js&"
export * from "./HelzbergCard.vue?vue&type=script&lang=js&"
import style0 from "./HelzbergCard.vue?vue&type=style&index=0&id=97296e36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97296e36",
  null
  
)

export default component.exports